import { render, staticRenderFns } from "./SerieCreate.vue?vue&type=template&id=bd8180fa&"
import script from "./SerieCreate.vue?vue&type=script&lang=js&"
export * from "./SerieCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports